import { HomeModernIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "@/features/feature.types";
import { buildCrudPermissions } from "@/features/shared/featureFactories";

const DashboardPage = lazy(() => import("./dashboard/pages/Dashboard"));

export const HOME_FEATURES = [
  {
    id: "dashboard",
    moduleName: "home",
    navigation: {
      label: "Dashboard",
      path: "/dashboard",
      icon: HomeModernIcon,
      order: 1,
    },
    guardianNavigation: {
      order: 1,
    },
    route: {
      path: "/dashboard",
      element: DashboardPage,
    },
    permissions: buildCrudPermissions("Home", "Dashboard", {
      view: "Analytics.Insights.view",
    }),
    readiness: "live",
  },
] as const satisfies readonly FeatureMetadata[];
